import backgroundImg from '@assets/web-v3-images/congratulation-popup.png';
import puzzlex5Img from '@assets/web-v3-images/icons/puzzlex5.png';
import imgPopup from '@assets/web-v3-images/img-popup.png';
import { Text } from '@radix-ui/themes';
import { Trans, useTranslation } from 'react-i18next';
import SuccessTurnPopup from '.';
import Buttons from '../Buttons';

function DayBadge({ children }) {
	return (
		<div className="relative inline-block">
			{/* Viền */}
			<span
				className="absolute inset-0 font-black select-none"
				style={{
					fontSize: "clamp(35px,5vw,60px)",
					WebkitTextStroke: "3px #F7E7A1",
					color: "transparent",
					paintOrder: "stroke fill",
				}}
			>
				{children}
			</span>
			{/* Chữ */}
			<span
				className="relative font-black bg-gradient-to-b from-[#F04438] to-[#B42318] bg-clip-text text-transparent"
				style={{ fontSize: "clamp(35px,5vw,60px)" }}
			>
				{children}
			</span>
		</div>
	);
}

export default function ReachedMilestones({
	currentStreak = 0,
	rewardAmount = 0,
	onOpenChange,
	open,
	handleClick,
	textBtn = 'Text btn',
	image
}) {
	const { t } = useTranslation()
	return (
		<SuccessTurnPopup
			open={open}
			onOpenChange={onOpenChange}
			backgroundImg={backgroundImg}
			title={t("shwe_journey.congratulations")}
		>
			<div className="flex flex-col items-center justify-center text-center pt-10 sm:pt-20 md:pt-20 lg:pt-20 xl:pt-20">
				<div className='relative w-[73%] mt-[16%]  mb-20'>
					<div className='flex flex-col px-5'>
						<Trans
							i18nKey="shwe_journey.reached_day"
							values={{ day: currentStreak }}
							components={{
								reached: (
									<Text className='text-[rgba(113,59,18,1)] font-extrabold text-[13px] sm:text-[23px]' />
								),
								dayBadge: <DayBadge />,
							}}
						/>
					</div>
					<div className="relative -mt-[12%] flex justify-center z-10">
						<img src={imgPopup} alt="img-popup" className="max-w-full w-[80%] h-auto" />
						<div className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] flex justify-center '>
							<div className='relative flex justify-center w-[50%] pr-[6%]'>
								<img src={image} alt="puzzle-5" className="h-auto w-[60%] sm:w-[80%] h-auto" />
								<div
									className='absolute bottom-0 right-5 sm:right-10'
									style={{
										perspective: "800px",
										transform: "rotateX(35deg)",
										transformOrigin: "bottom center",
									}}
								>
									<div className="relative inline-block">
										{/* Viền */}
										<span
											className="absolute inset-0 font-black select-none"
											style={{
												fontSize: "clamp(34px,4vw,50px)",
												WebkitTextStroke: "7px rgba(147, 47, 25, 1)",
												color: "transparent",
												paintOrder: "stroke fill",
											}}
										>
											x{rewardAmount}
										</span>

										{/* Chữ */}
										<span
											className="
												relative
												font-black
												bg-gradient-to-b
												from-[rgba(254,253,240,1)]
												to-[rgba(254,238,149,1)]
												bg-clip-text
												text-transparent
											"
											style={{
												fontSize: "clamp(34px,4vw,50px)",
											}}
										>
											x{rewardAmount}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div className='
									absolute
									left-1/4
									bottom-0
							-translate-x-1/6
							px-[7%]
					'>
							<Buttons handleClick={handleClick} textBtn={textBtn} classItemText="!text-[14px] sm:!text-[22px]" />
						</div>
					</div>
				</div>

			</div>
		</SuccessTurnPopup>
	)
}
